import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
declare var jQuery: any;
declare var $: any;

@Component({
	selector: 'app-ground-regulations',
	templateUrl: './ground-regulations.component.html',
	styleUrls: ['./ground-regulations.component.scss']
})
export class GroundRegulationsComponent implements OnInit {

	historyList: any = "";
	honoursList: any = "";
	recordsList: any = "";
	museumList: any = "";
	committeeList: any = "";
	meetboardList: any = "";
	governanceList: any = "";
	aboutfoxList: any = "";
	aboutfoxkeyList: any = "";
	runningkeyList: any = "";
	bannerrequest: any = {};
	leicestershirerequest: any = {};
	soccontentRequest: any = {};
	bannerList: any = "";
	soccontentList: any = "";
	groundList: any = "";
	clubfriendsList: any = "";
	clubcommitteeList: any = "";
	historyrichprodList: any = "";
	bannerbottomList: any = "";
	safeguardingList: any = "";
	leicestershireList: any = "";

	currentURL='';
	newurl: any = "";
	constructor(private allpagesService: AllPageService,
		private activatedRoute:ActivatedRoute,
    private router: Router,) {
		this.currentURL = window.location.href;
		//console.log(this.currentURL);
		this.newurl = this.currentURL.split("/", 5); 
		this.tabactive(this.newurl[4]);
	 }
	slideoperateConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 4,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
				},
			},
		],
	};
	slidefrienddraceConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 4,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	ngOnInit() {
		
		this.activatedRoute.params.subscribe((data)=>{
			if(data.slug){
				this.tabactive(data.slug);
			  //console.log(data.slug);
			  //this.newsRequest = data.slug;
			}
			
			});

		this.loadBanner();
		this.loadBannerbottom();
		this.loadleicestershire();
		this.loadcontent();
		this.allpagesService.getHistoryofLccc().then((data) => {
			this.historyList = data;
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);

		});

		this.allpagesService.getHistoryHonours().then((data) => {
			this.honoursList = data;
			//console.warn(this.honoursList);
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);
		});

		this.allpagesService.getHistoryRecords().then((data) => {
			this.recordsList = data;
			//console.warn(this.recordsList);
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);
		});

		this.allpagesService.getHistorymuseum().then((data) => {
			this.museumList = data;
			//console.warn(this.museumList);
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);
		});

		this.allpagesService.getHistoryCommittee().then((data) => {
			this.committeeList = data;
			//console.warn(this.committeeList);
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);
		});

		this.allpagesService.getClubMeetboard().then((data) => {
			this.meetboardList = data;
			console.warn(this.meetboardList);
			setTimeout(() => {
				this.tabactive(this.newurl[4]);
				jQuery('.popup-login').magnificPopup({
					type: 'inline',
					mainClass: 'mfp-fade',
					removalDelay: 160,
					preloader: false,
		  
					fixedContentPos: false,
					callbacks: {
					  open: function() {
						jQuery("body").addClass("overflow");
					  },
					  close: function() {
						jQuery("body").removeClass("overflow");
					  }
					  // e.t.c.
					}
				  });
				
			}, 1000);
		});

		this.allpagesService.getClubGovernance().then((data) => {
			this.governanceList = data;
			//console.warn(this.meetboardList);
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);
		});

		this.allpagesService.getClubAboutfox().then((data) => {
			this.aboutfoxList = data.data[0];
			this.aboutfoxkeyList = data.data[1];
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);
			//console.warn(this.aboutfoxkeyList);
		});

		this.allpagesService.getClubRunningkey().then((data) => {
			this.runningkeyList = data;
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);
			//console.warn(this.runningkeyList);
		});

		this.allpagesService.getClubFriendsgrace().then((data) => {
			this.clubfriendsList = data.data[0];
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);
			//console.warn(this.runningkeyList);
		});

	

		this.allpagesService.getClubCommittee().then((data) => {
			this.clubcommitteeList = data;
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);
			//console.warn(this.runningkeyList);
		});

		this.allpagesService.getHistoryrichProud().then((data) => {
			this.historyrichprodList = data;
			//console.warn(this.historyrichprodList);
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);
		});


		this.allpagesService.getHistoryGround().then((data) => {
			this.groundList = data;
			//console.warn(this.runningkeyList);
			setTimeout(() => {
				this.tabactive(this.newurl[4]);
				jQuery(".ground-hero-developments-top ul li").click(function () {
					if (jQuery(this).hasClass('active')) {
						// do nothing
					} else {
						jQuery(".ground-hero-developments-top ul li").removeClass('active');
						jQuery(this).addClass('active');
					}
					return false;
				});

				jQuery('.open-popup-link').magnificPopup({
				  type: 'inline',
				  midClick: true,
				  mainClass: 'mfp-fade'
				});
			}, 1000);
		});

		jQuery(".courses-name").click(function () {
			if (jQuery(this).hasClass('active')) {
				// do nothing
			} else {
				var tabid = jQuery(this).attr('id');
				jQuery(".courses-name").removeClass('active');
				jQuery(this).addClass('active');
				jQuery(".course-main-content").removeClass('active');
				jQuery("#" + tabid + "-content").addClass("active");
				console.warn(tabid);
			}
			return false;
		});

		this.allpagesService.getclubsafeguarding().then((data) => {
			this.safeguardingList = data;
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);
			//console.warn(this.safeguardingList);
		});


	}

	tabactive(slug) {
		jQuery(".courses-name").removeClass('active');
		jQuery(".course-main-content").removeClass('active');
		if(slug == 'history'){
			jQuery("#history").addClass('active');
			jQuery("#history-content").addClass("active");		
		}else if(slug == 'meet-the-board'){
			jQuery("#meet-the-board").addClass('active');
			jQuery("#meet-the-board-content").addClass("active");
		}else if(slug == 'governance'){
			jQuery("#governance").addClass('active');
			jQuery("#governance-content").addClass("active");
		}else if(slug == 'safeguarding'){
			jQuery("#safeguarding").addClass('active');
			jQuery("#safeguarding-content").addClass("active");
		}else if(slug == 'friends-of-grace-road'){
			jQuery("#friend-grace-road").addClass('active');
			jQuery("#friend-grace-road-content").addClass("active");
		}else if(slug == 'honours'){
			jQuery("#honours").addClass('active');
			jQuery("#honours-content").addClass("active");
		}else if(slug == 'museum'){
			jQuery("#museum").addClass('active');
			jQuery("#museum-content").addClass("active");
		}else if(slug == 'leicestershire-cricket-society'){
			jQuery("#leicestershire-cricket-society").addClass('active');
			jQuery("#leicestershire-cricket-society-content").addClass("active");
		}
		else if(slug == 'about'){
			jQuery("#about-the-running").addClass('active');
			jQuery("#about-the-running-content").addClass("active");
		}
		else{
			jQuery("#about-the-running").addClass('active');
			jQuery("#about-the-running-content").addClass("active");
		}
	}

	loadleicestershire(){
		this.leicestershirerequest = {
			type: 'Leicestershire Cricket Society'
		};
		let request = Object.assign({}, this.leicestershirerequest);
		this.allpagesService.getClubFriendsgrace(request).then((data) => {
			this.leicestershireList = data.data[0];
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);
			//console.warn(this.runningkeyList);
		});
	}
	loadBanner() {
		this.bannerrequest = {
			title: 'About the Running Foxes'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.bannerList = data.data[0];
			//console.log(this.bannerList);
		});
	}

	loadBannerbottom() {
		this.bannerrequest = {
			title: 'About the Running Foxes Bottom'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.bannerbottomList = data.data[0];
			//console.log(this.bannerList);
		});
	}
	loadcontent(){
		this.soccontentRequest = {
			title: 'Leicestershire Cricket Society'
		}
		let request = Object.assign({}, this.soccontentRequest);
		this.allpagesService.getContenttext(request).then((data: any) => {
			this.soccontentList = data.data[0];
			console.warn(this.soccontentList);
		});
	}

}
